module.exports = __webpack_public_path__ + "img/LowerTeeth.94519b5a.png";